import { createFileRoute } from "@tanstack/react-router";
import { DeletedScreen, type DeletedSearch } from "../screens/staff/DeletedScreen.tsx";

/**
 * `/sysadmin/deleted`: companies inside their 30 days, with a way back, and the former-customer record. Restoring
 * asks the person to type the company's name (the gate's strong confirmation) and says what stays ended.
 */
export const Route = createFileRoute("/_staff/sysadmin/deleted")({
  validateSearch: (search: Record<string, unknown>): DeletedSearch =>
    search.tab === "former" ? { tab: "former" } : {},
  component: DeletedScreen,
});
